import React from 'react';
import PropTypes from 'prop-types';

const Label = ({value, target}) => (
  <label
    className="block mb-1 text-grey-darkest font-medium text-12 uppercase"
    htmlFor={target}>
    {value}
  </label>
);

Label.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  target: PropTypes.string,
};

export default Label;
